import { Box, Typography } from '@mui/material'

import { TOutreach } from '~/features/campaigns/models'

type TOutreachEmailPreviewPayload = {
  outreach: TOutreach
}

export default function OutreachEmailPreview({
  outreach,
}: TOutreachEmailPreviewPayload) {
  return (
    <>
      {outreach.emailSubject && (
        <Box>
          <Typography variant="body2" fontWeight={600}>
            Email Subject:
          </Typography>
          <Typography variant="body2">{outreach.emailSubject}</Typography>
        </Box>
      )}
      {outreach.emailBody && (
        <Box>
          <Typography variant="body2" fontWeight={600}>
            Email body:
          </Typography>
          <Typography
            variant="body2"
            sx={{
              whiteSpace: 'pre-wrap',
              fontFamily: 'inherit',
            }}
          >
            {outreach.emailBody}
          </Typography>
        </Box>
      )}
    </>
  )
}
